import AxiosInterceptor from "../../AxiosInterceptorHearro";

// 히어로 관리자 서비스의 사용자 정보를 조회
export function getUserInfoFromHearro() {
	return AxiosInterceptor({
		url: '/signup/dpdtx002admin',
		method: 'get'
	})
}


// 히어로 사용자 프로필 이미지 조회
export function getUserProfileImageFromHearro() {
	return AxiosInterceptor({
		url: '/staff/profile-img',
		method: 'get'
	})
}

// 히어로 사용자 프로필 이미지 업로드
export function putUserProfileImageToHearro(request) {
	return AxiosInterceptor({
		url: '/staff/profile-img',
		method: 'put',
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		data: request
	})
}

// 히어로 사용자(의료진) 로그인 기록 조회
// request data
//	- start : 시작 날짜
//	- end : 끝 날짜
// 	- page : 페이지 번호
export function getUserLoginHistoryFromHearro(request) {
    return AxiosInterceptor({
        url: '/staff/his/login',
        method: 'get',
		params: request
    })
}

// 히어로 사용자 로그인 기록 post
export function postUserLoginHistoryToHearro() {
	return AxiosInterceptor({
		url: '/base/recode/login',
		method: 'post'
	})
}

// 히어로 서비스 회원 탈퇴 (서비스 가입 정보 삭제)
export function deleteUserFromHearro() {
	return AxiosInterceptor({
		url: '/signup/dpdtx002Admin',
		method: 'delete'
	})
}